export const renewalIntimationEndpoints = (builder) => ({
    getRenewalIntimationList: builder.query({
        query: (args = {}) => {
            const {
                renewalFrom,
                renewalTo,
                mode,
                product,
                pageNumber,
                pageSize,
                sortField,
                sortDirection
            } = args;

            const params = {
                renewalFrom,
                renewalTo,
            };

            if (mode) params.mode = mode;
            if (product) params.product = product;
            if (pageNumber !== undefined) params.pageNumber = pageNumber;
            if (pageSize !== undefined) params.pageSize = pageSize;
            if (sortField !== undefined) params.sortField = sortField;
            if (sortDirection !== undefined) params.sortDirection = sortDirection;

            return {
                url: '/GeneralInsurance/get-renewal-intimation-list',
                method: 'POST',
                body: params,
            };
        },
        providesTags: ['RenewalIntimation'],
    }),
    sendRenewalCommunication: builder.mutation({
        query: (payload) => ({
            url: '/GeneralInsurance/send-renewal-communication',
            method: 'POST',
            body: payload,
        }),
    }),
});
